import { FunctionComponent, InputHTMLAttributes, ReactNode } from "react";
import * as Styled from "./styles";

import { Checkbox } from "@manifesthhqinc/ui-library";

interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  isChecked: boolean;
  label?: string | ReactNode;
  error?: boolean;
  onToggleCheckbox: (e: boolean) => void;
}

const CheckBox: FunctionComponent<CheckBoxProps> = ({ isChecked, label, onToggleCheckbox }: CheckBoxProps) => {
  const onChangeHandler = () => {
    onToggleCheckbox(!isChecked);
  };

  return (
    <Styled.CheckboxDiv>
      <Styled.CheckboxIcon>
        <Checkbox isChecked={isChecked} onChange={onChangeHandler} />
      </Styled.CheckboxIcon>
      {label && <p>{label}</p>}
    </Styled.CheckboxDiv>
  );
};

export default CheckBox;
